import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from '../models/tree-node.model';

@Component({
    selector: 'mh-tree-node',
    templateUrl: './tree-node.component.html',
    styles: [],
    standalone: false
})
export class TreeNodeComponent {
  @Input() node!: TreeNode;
  @Input() depth: number = 0;
  @Input() activeNodeId: string | number | null = null;

  @Output() nodeClicked = new EventEmitter <{ node: TreeNode, event: MouseEvent }>();

  onNodeClick(node: TreeNode, event: MouseEvent): void {
    // Emitimos el evento hacia el componente padre para que maneje la lógica compleja
    this.nodeClicked.emit({ node, event });
  }
}
